import { Strike as StrikeExtension } from '@tiptap/extension-strike';

export const Strike = StrikeExtension.extend({
  addOptions() {
    return {
      HTMLAttributes: {},
      types: ['textStyle'],
    };
  },
  parseHTML() {
    const parentConfig = this.parent?.() ?? [];
    return [
      ...parentConfig,
      {
        // For lesson-conversion, used in classic editor
        style: 'text-decoration-line',
        consuming: false,
        getAttrs: (value) => value.toString().includes('line-through') && null,
      },
    ];
  },
});
